import { BookOpen, Bug, FlaskConical, Package, Rocket, ShieldCheck, Sparkles, Wrench } from '@orgus/ui/icons';
import type { ComponentType } from 'react';
import type { TemplateIcon as Icon } from '@orgus/protocol';

export const TEMPLATE_ICON: Record<Icon, ComponentType<{ className?: string }>> = {
  test: FlaskConical,
  docs: BookOpen,
  package: Package,
  bug: Bug,
  sparkles: Sparkles,
  wrench: Wrench,
  shield: ShieldCheck,
  rocket: Rocket,
};

export const TEMPLATE_ICON_LABEL: Record<Icon, string> = {
  test: 'Tests',
  docs: 'Docs',
  package: 'Package',
  bug: 'Bug',
  sparkles: 'Sparkles',
  wrench: 'Wrench',
  shield: 'Shield',
  rocket: 'Rocket',
};

export function TemplateIcon({ icon, className }: { icon: Icon; className?: string }) {
  const C = TEMPLATE_ICON[icon] ?? Sparkles;
  return <C className={className} />;
}
